import React from 'react';

function BlockAAndB() {
  return (
    <>
      <style>
        {`
          .form-header {
            background-color: #f8f9fa;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
            position: relative;
          }
          .form-title {
            color: #1976d2;
            font-size: 20px;
            font-weight: bold;
            margin: 0;
            text-align: center;
          }
          .confidential-badge {
            background-color: #dc3545;
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            position: absolute;
            top: 15px;
            right: 20px;
            z-index: 10;
          }
          .block-container {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
          }
          .block-title {
            background-color: #e3f2fd;
            color: #1976d2;
            font-size: 16px;
            font-weight: bold;
            padding: 10px 15px;
            margin: -20px -20px 20px -20px;
            border-radius: 6px 6px 0 0;
            border-bottom: 1px solid #1976d2;
          }
          .form-group {
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
          }
          .form-label {
            font-weight: 600;
            color: #333;
            margin-bottom: 0;
            font-size: 14px;
            min-width: 250px;
            margin-right: 15px;
            flex-shrink: 0;
          }
          .form-label.section-label {
            min-width: 100%;
            margin-bottom: 10px;
            margin-right: 0;
            font-size: 15px;
            font-weight: 700;
          }
          .form-control {
            border: none;
            border-bottom: 1px solid #333;
            border-radius: 0;
            padding: 4px 0;
            font-size: 14px;
            background-color: transparent;
            width: 200px;
            flex-shrink: 0;
            outline: none;
          }
          .form-control:focus {
            border-bottom: 2px solid #333;
            box-shadow: none;
          }
          .address-section {
            background-color: #f8f9fa;
            padding: 15px;
            border-radius: 4px;
            margin-bottom: 15px;
            width: 100%;
          }
          .address-section .form-group {
            margin-bottom: 10px;
          }
          .address-section .form-label {
            min-width: 120px;
            font-size: 13px;
          }
          .address-section .form-control {
            width: 180px;
            border: none;
            border-bottom: 1px solid #333;
            border-radius: 0;
            padding: 4px 0;
            background-color: transparent;
            outline: none;
          }
          @media (max-width: 768px) {
            .form-group {
              flex-direction: column;
              align-items: flex-start;
            }
            .form-label {
              min-width: 100%;
              margin-bottom: 5px;
              margin-right: 0;
            }
            .form-control {
              width: 100%;
              max-width: 300px;
            }
            .address-section .form-group {
              flex-direction: row;
              align-items: center;
            }
            .address-section .form-label {
              min-width: 120px;
              margin-bottom: 0;
              margin-right: 10px;
            }
            .address-section .form-control {
              width: 150px;
            }
          }
          .form-control:focus {
            border-color: #1976d2;
            box-shadow: 0 0 0 0.2rem rgba(25, 118, 210, 0.25);
          }
          .readonly-field {
            background-color: transparent !important;
            color: #333;
            font-weight: 500;
            border: none;
            border-bottom: 1px solid #333;
            border-radius: 0;
            padding: 4px 0;
            outline: none;
          }
          .address-section {
            background-color: #f8f9fa;
            padding: 15px;
            border-radius: 4px;
            margin-bottom: 15px;
          }
          .declaration-section {
            background-color: #fff3cd;
            border: 1px solid #ffeaa7;
            border-radius: 6px;
            padding: 20px;
            margin-top: 20px;
          }
          .declaration-text {
            font-style: italic;
            color: #856404;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            gap: 10px;
          }
          .declaration-checkbox {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            cursor: not-allowed;
          }
          .signature-section {
            margin-top: 20px;
            padding-top: 15px;
            border-top: 1px solid #ddd;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="form-header">
          <div className="confidential-badge">CONFIDENTIAL</div>
          <h1 className="form-title">Government of India</h1>
          <p className="text-center mb-1" style={{ color: '#333', fontSize: '16px', fontWeight: '500' }}>
            Ministry of Statistics and Programme Implementation
          </p>
          <p className="text-center mb-1" style={{ color: '#333', fontSize: '14px' }}>
            Return under Collection of Statistics Act, 2008 and Rules framed there under in 2011
          </p>
          <p className="text-center mb-1" style={{ color: '#333', fontSize: '16px', fontWeight: 'bold' }}>
            Annual Survey of Industries 2022-23 (Part-I)
          </p>
          <p className="text-center mb-0" style={{ color: '#333', fontSize: '12px', fontStyle: 'italic' }}>
            (Please read the instructions before filling the return)
          </p>
        </div>

        {/* Main Form Content */}
        <div className="row">
          {/* Block A: Identification Particulars */}
          <div className="col-md-6">
            <div className="block-container">
              <div className="block-title">Block A: Identification Particulars (For Official use)</div>
              
              <div className="form-group">
                <label className="form-label">1. Schedule Despatch No.</label>
                <input type="text" className="form-control readonly-field" defaultValue="404936" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">2. PSL No.</label>
                <input type="text" className="form-control readonly-field" defaultValue="31186" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">3. Scheme Code (Census-1, Sample-2)</label>
                <input type="text" className="form-control readonly-field" defaultValue="2" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">4. Ind. Code as per Frame (4-digit level of NIC-2008)</label>
                <input type="text" className="form-control readonly-field" defaultValue="2392" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">5. Ind. Code as per Return (5-digit level of NIC-2008)</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">6. Description of Industry</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">7. State Code</label>
                <input type="text" className="form-control readonly-field" defaultValue="09" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">8. District Code</label>
                <input type="text" className="form-control readonly-field" defaultValue="09" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">9. Sector (Rural-1, Urban-2)</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">10. RO/SRO Code</label>
                <input type="text" className="form-control readonly-field" defaultValue="0912" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">11. No. of units</label>
                <input type="text" className="form-control readonly-field" defaultValue="1" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">12. Status of unit (Code)</label>
                <input type="text" className="form-control" readOnly />
              </div>
            </div>
          </div>

          {/* Block B: Particulars of the Factory */}
          <div className="col-md-6">
            <div className="block-container">
              <div className="block-title">Block B: Particulars of the Factory (To be filled by owner of the factory)</div>
              
              <div className="form-group">
                <label className="form-label section-label">1. Name and address of the Industrial Undertaking</label>
                <div className="address-section">
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">Name:</label>
                    <input type="text" className="form-control readonly-field" defaultValue="DEV BRICK FIELD" readOnly />
                  </div>
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">Address Line 1:</label>
                    <input type="text" className="form-control readonly-field" defaultValue="VILL-MATHURAPUR" readOnly />
                  </div>
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">Town:</label>
                    <input type="text" className="form-control" readOnly />
                  </div>
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">District:</label>
                    <input type="text" className="form-control readonly-field" defaultValue="GHAZIABAD" readOnly />
                  </div>
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">State:</label>
                    <input type="text" className="form-control readonly-field" defaultValue="Uttar Pradesh" readOnly />
                  </div>
                  <div className="form-group mb-0">
                    <label className="form-label mb-1">Pincode:</label>
                    <input type="text" className="form-control" readOnly />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">2. Type of organisation (Code)</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">3. Corporate Identification Number (CIN)</label>
                <input type="text" className="form-control readonly-field" defaultValue="L01631KA2010PTC096843" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">4. Whether the unit has ISO Certification, 14000 Series (yes - 1, No-2)</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">5. Year of initial production</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">6. Accounting Year (MMYY to MMYY)</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">7. Number of months of operation</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">8. Whether the share capital of the company includes share of foreign entities (yes-1, no-2)</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label">9. Any RD unit in your factory (yes registered with DST/DBT-1, yes registered with others-2, no-3)</label>
                <input type="text" className="form-control" readOnly />
              </div>

              <div className="form-group">
                <label className="form-label section-label">10. Details of contact person</label>
                <div className="address-section">
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">i. Name & designation of contact person:</label>
                    <input type="text" className="form-control" readOnly />
                  </div>
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">ii. Tele (with STD Code):</label>
                    <input type="text" className="form-control" readOnly />
                  </div>
                  <div className="form-group mb-2">
                    <label className="form-label mb-1">iii. FAX:</label>
                    <input type="text" className="form-control" readOnly />
                  </div>
                  <div className="form-group mb-0">
                    <label className="form-label mb-1">iv. E-mail:</label>
                    <input type="email" className="form-control" readOnly />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">11. Whether the unit offered any formal training?</label>
                <input type="text" className="form-control" readOnly />
              </div>
            </div>
          </div>
        </div>

        {/* Declaration Section */}
        <div className="declaration-section">
          <div className="declaration-text">
            <input type="checkbox" className="declaration-checkbox" readOnly />
            I hereby declare that information furnished in this return is correct and complete to the best of my knowledge and belief
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">Date:</label>
                <input type="text" className="form-control readonly-field" defaultValue="26-Sep-25" readOnly />
              </div>
              <div className="form-group">
                <label className="form-label">Place:</label>
                <input type="text" className="form-control" readOnly />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label">Name and Signature of owner with stamp</label>
                <input type="text" className="form-control" readOnly />
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1" onClick={() => window.print()}>
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            {/* <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button> */}
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockAAndB; 